import moment from "moment";
import { VERSION } from '@configs/constants';

const initialState = {
    users_list:[],
    wax:window.wax,
    user: {
        photoUrl:null,
        pubKeys:null,
        userAccount:null,
        type:null,
        role:{
            id:0
        }
    }
}
const bytenize = (str) =>{
  str = str ?? ""
  var bytes = [];
  var charCode;

  for (var i = 0; i < str.length; ++i)
  {
      charCode = str.charCodeAt(i);
      bytes.push((charCode & 0xFF00) >> 8);
      bytes.push(charCode & 0xFF);
  }
  return bytes.join(' ');
}
const getSessionId = () =>{
  return window.socket.id;
}
const authorizedUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_USER_THUMB":
            let thumb = action.data.length > 0 && action.data[0].photo_hash ? "https://ipfs.io/ipfs/"+action.data[0].photo_hash : false;
            return {...state, user: {...state.user, photoUrl:thumb}};
        case "FETCH_USERS":
            return {...state, users_list: action.users};
        case "LOGOUT":
          localStorage.removeItem('wax-login');
          localStorage.removeItem('ssn');
          return {...state, user: {...state.user, photoUrl:null, pubKeys: null, userAccount: null}, wax: window.wax};
        case "WAX_LOGIN":
            window.socket.emit('action', {
                action:'login',
                version:VERSION,
                userAccount:{
                    nl:true,
                    pubKeys: action.pubKeys,
                    type:'cloud',
                    s:bytenize(getSessionId()),
                    identity:action.identity,
                    userAccount: action.userAccount,
                    ssn:localStorage.getItem('ssn', null)
                }
            })
            return {...state, user: {
                    ...state.user, 
                    pubKeys: action.pubKeys,
                    type:'cloud',
                    userAccount: action.userAccount
                }
            };
        case "ORE_LOGIN":
            window.socket.emit('action', {
                action:'login',
                version:VERSION,
                userAccount:{
                    nl:true,
                    pubKeys: action.pubKeys,
                    type:'ore',
                    s:bytenize(getSessionId()),
                    identity:action.identity,
                    userAccount: action.userAccount,
                    ssn:localStorage.getItem('ssn', null)
                }
            })
            return {...state, user: {
                    ...state.user, 
                    pubKeys: action.pubKeys,
                    type:'ore',
                    userAccount: action.userAccount
                }
            };
        case "ANCHOR_LOGIN":
            console.log(['ANCHOR_LOGIN', {
                action:'login',
                version:VERSION,
                userAccount:{
                    nl:true,
                    pubKeys: action.pubKeys,
                    identity:action.identity,
                    type:'anchor',
                    s:bytenize(getSessionId()),
                    userAccount: action.userAccount,
                    ssn:localStorage.getItem('ssn', null)
                }
            }])
            window.socket.emit('action', {
                action:'login',
                version:VERSION,
                userAccount:{
                    nl:true,
                    pubKeys: action.pubKeys,
                    identity:action.identity,
                    type:'anchor',
                    s:bytenize(getSessionId()),
                    userAccount: action.userAccount,
                    ssn:localStorage.getItem('ssn', null)
                }
            })
            return {...state, user: {
                    ...state.user, 
                    type:'anchor',
                    pubKeys: action.pubKeys,
                    userAccount: action.userAccount, 
                }
            };
        case "WOMBAT_LOGIN":
                window.socket.emit('action', {
                    action:'login',
                    version:VERSION,
                    userAccount:{
                    nl:true,
                        pubKeys: action.pubKeys,
                        type:'wombat',
                        s:bytenize(getSessionId()),
                        identity:action.identity,
                        userAccount: action.userAccount,
                        ssn:localStorage.getItem('ssn', null)
                    }
                })
                return {...state, user: {
                        ...state.user,
                        type:'wombat',
                        pubKeys: action.pubKeys,
                        userAccount: action.userAccount,
                    }
                };
        case "REQUEST_NONCE":
          window.socket.emit('action', {
            action:'requestNonce'
          })
          return state
        default:
            return state
    }
};

export default authorizedUserReducer
